<template lang="pug">
  div
    validation-observer(
      ref="personalDataForm"
      v-slot="{ handleSubmit }"
    )
      form.form(@submit.prevent="handleSubmit($store.commit('SET_STEP', 2))")
        .form-item.has-bg.mb-5
          validation-provider(
            v-slot="{ errors, valid }"
            rules="required"
            name="ตำแหน่งที่สมัคร"
          )
            .form-group.row.mb-4
              label.col-sm-2(
                for="position"
              ) ตำแหน่งที่สมัคร

              .col-sm-10
                input.form-control#position(
                  type="text"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="form.position"
                  @input="onChange"
                )
                span.invalid-feedback {{ errors[0] }}
                //- select.custom-select#position(
                //-   :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                //-   v-model="form.position"
                //-   @change="onChange"
                //- )
                //-   option(value="1") 1
                //-   option(value="2") 2
                //-   option(value="3") 3
                //- span.invalid-feedback {{ errors[0] }}

          .row
            .col
              validation-provider(
                v-slot="{ errors, valid }"
                rules="required"
                name="เงินเดือนที่คาดหวัง"
              )
                .form-group.row
                  label.col-sm-4(for="expected-salary") เงินเดือนที่คาดหวัง
                  .col-sm-8
                    input.form-control#expected-salary(
                      type="number"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      v-model="form.expected_salary"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}


            .col
              validation-provider(
                v-slot="{ errors, valid }"
                rules="required"
                name="สาขาวิชา"
              )
                .form-group.row
                  label.col-sm-3.text-right(for="expected-salary") สาขาวิชา
                  .col-sm-9
                    input.form-control#expected-salary(
                      type="text"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      v-model="form.field_study"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}

        h3.form-title.text-center ส่วนที่ 1 : ประวัติส่วนตัว

        .row
          .col-md-9
            .form-item.has-bg.mr-2rem
              validation-provider(
                v-slot="{ errors, valid }"
                rules="required"
                name="ตำแหน่งที่สมัคร"
              )
                .form-group.row
                  label.col-sm-2(
                    for="nameTitle"
                  ) คำนำหน้าชื่อ

                  .col-sm-10.pl-75.d-flex
                    .custom-control.custom-radio.custom-control-inline(
                      v-for="(item, index) in nameTitle"
                      :key="index"
                    )
                      input.custom-control-input(
                        :id="`#nameTitle${index}`"
                        type="radio"
                        :value="item.value"
                        v-model="form.name_title"
                        @change="onChange"
                      )
                      label.custom-control-label(:for="`#nameTitle${index}`") {{ item.label }}

                    .custom-control.custom-control-inline
                      .form-group
                        input.form-control.name-title-other(
                          type="text"
                          v-model="form.name_title_other"
                          @input="onChange"
                          :disabled="form.name_title !== 'อื่นๆ โปรดระบุ'"
                        )
                        span.invalid-feedback {{ errors[0] }}


            .form-item.mr-2rem
              .form-group.row
                label.col-sm-2(
                  for="nameTitle"
                ) ชื่อ - นามสกุล

                .col-sm-10.pl-75
                  .row
                    .col
                      validation-provider(
                        v-slot="{ errors, valid }"
                        rules="required"
                        name="ชื่อจริง"
                      )
                        .form-group
                          input.form-control#nameTitle(
                            type="text"
                            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                            v-model="form.firstname"
                            @input="onChange"
                            placeholder="ชื่อจริง"
                          )
                          span.invalid-feedback {{ errors[0] }}

                    .col
                      validation-provider(
                        v-slot="{ errors, valid }"
                        rules="required"
                        name="นามสกุล"
                      )
                        .form-group
                          input.form-control#lastname(
                            type="text"
                            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                            v-model="form.lastname"
                            @input="onChange"
                            placeholder="นามสกุล"
                          )
                          span.invalid-feedback {{ errors[0] }}

            .form-item.has-bg.mr-2rem
              .row
                label.col-sm-2(
                  for="nameTitleEn"
                ) Name - Surname

                .col-sm-10.pl-75
                  .row
                    .col
                      validation-provider(
                        v-slot="{ errors, valid }"
                        rules="required"
                        name="Name"
                      )
                        .form-group
                          input.form-control#nameTitleEn(
                            type="text"
                            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                            v-model="form.firstname_en"
                            @input="onChange"
                            placeholder="Name"
                          )
                          span.invalid-feedback {{ errors[0] }}

                    .col
                      validation-provider(
                        v-slot="{ errors, valid }"
                        rules="required"
                        name="Surname"
                      )
                        .form-group
                          input.form-control#lastname(
                            type="text"
                            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                            v-model="form.lastname_en"
                            @input="onChange"
                            placeholder="Surname"
                          )
                          span.invalid-feedback {{ errors[0] }}
          .col-md-3 
            .profile
              label.text-center(
                :style="`background-image:url(${form.profile_url})`"
                :class="{ 'is-valid' : form.profile_url }"
              )
                div
                  icon-upload-profile.icon
                  span.d-block อัปโหลดรูปถ่ายหน้าตรง
                    small.d-block (ขนาดไฟล์ไม่เกิน 2 mb)
                  input(
                    ref="file2"
                    type="file"
                    accept="image/x-png,image/gif,image/jpeg"
                    @change="onFileChange"
                  )

        .form-item
          .row
            .col-sm-4
              .row
                label.col-sm-6(
                  for="age"
                ) อายุ

                .col-sm-6
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="อายุ"
                  )
                    .form-group
                      input.form-control#age(
                        type="number"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.age"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-4
              .row
                label.col-sm-6.text-right(
                  for="weight"
                ) น้ำหนัก(ก.ก)

                .col-sm-6
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="น้ำหนัก(ก.ก)"
                  )
                    .form-group
                      input.form-control#weight(
                        type="number"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.weight"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-4
              .row
                label.col-sm-6.text-right(
                  for="height"
                ) ส่วนสูง(ซม.)

                .col-sm-6
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="ส่วนสูง(ซม.)"
                  )
                    .form-group
                      input.form-control#height(
                        type="number"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.height"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}


        .form-item.has-bg
          .row
            .col-sm-4
              .row
                label.col-sm-6(
                  for="race"
                ) เชื้อชาติ

                .col-sm-6
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="เชื้อชาติ"
                  )
                    .form-group
                      input.form-control#race(
                        type="text"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.race"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-4
              .row
                label.col-sm-6.text-right(
                  for="nationality"
                ) สัญชาติ

                .col-sm-6
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="สัญชาติ"
                  )
                    .form-group
                      input.form-control#firstname(
                        type="text"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.nationality"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-4
              .row
                label.col-sm-6.text-right(
                  for="religion"
                ) ศาสนา

                .col-sm-6
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="ศาสนา"
                  )
                    .form-group
                      input.form-control#religion(
                        type="text"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.religion"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}


        .form-item
          .row
            .col-sm-6
              .row
                label.col-sm-4(
                  for="email"
                ) อีเมล์

                .col-sm-8
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="อีเมล์"
                  )
                    .form-group
                      input.form-control#email(
                        type="email"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.email"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-6
              .row
                label.col-sm-4.text-right(
                  for="phoneNumber"
                ) เบอร์โทรศัพท์ที่ติดต่อ

                .col-sm-8
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="เบอร์โทรศัพท์ที่ติดต่อ"
                  )
                    .form-group
                      input.form-control#phoneNumber(
                        type="tel"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.phone_number"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}

        div.form-item.has-bg
          .row
            .col-sm-5
              .row
                label.col-sm-5(
                  for="idCardNumber"
                ) เลขที่บัตรประชาชน

                .col-sm-7
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="เลขที่บัตรประชาชน"
                  )
                    .form-group.ml-9px
                      input.form-control#idCardNumber(
                        type="number"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.id_card_number"
                        @input="onChange"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-7
              .row
                label.col-sm-3.text-right สถานทางสมรส

                .col-sm-9
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="สถานทางสมรส"
                  ).d-flex
                    .custom-control.custom-radio.custom-control-inline.mr-4(
                      v-for="(item, index) in maritalStatus"
                      :key="index"
                    )
                      input.custom-control-input(
                        :id="`maritalStatus${index}`"
                        type="radio"
                        :value="item.value"
                        v-model="form.marital_status"
                        @change="onChange"
                      )
                      label.custom-control-label(:for="`maritalStatus${index}`") {{ item.label }}

        .form-item
          validation-provider(
            v-slot="{ errors, valid }"
            rules="required"
            name="สถานทางทหาร"
          )
            .form-group.row
              label.col-sm-2 สถานทางทหาร

              div.col-sm-10.d-flex
                .custom-control.custom-radio.custom-control-inline(
                  v-for="(item, index) in militaryStatus"
                  :key="index"
                )
                  input.custom-control-input(
                    :id="`#militaryStatus${index}`"
                    type="radio"
                    :value="item.value"
                    v-model="form.military_status"
                    @change="onChange"
                  )
                  label.custom-control-label(:for="`#militaryStatus${index}`") {{ item.label }}

        .form-item.has-bg
          .row
            label.col-sm-2 ที่อยู่

            .col-sm-10
              .row
                .col
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="บ้านเลขที่"
                  )
                    .form-group
                      input.form-control#house_no(
                        type="text"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.house_no"
                        @input="onChange"
                        placeholder="บ้านเลขที่"
                      )
                      span.invalid-feedback {{ errors[0] }}
  
                .col
                  .form-group
                    input.form-control#building(
                      type="text"
                      v-model="form.building"
                      @input="onChange"
                      placeholder="อาคาร"
                    )

                .col
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="หมู่"
                  )
                    .form-group
                      input.form-control#villageNo(
                        type="number"
                        :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                        v-model="form.village_no"
                        @input="onChange"
                        placeholder="หมู่"
                      )
                      span.invalid-feedback {{ errors[0] }}

                .col
                  .form-group
                    input.form-control#lane(
                      type="text"
                      v-model="form.lane"
                      @input="onChange"
                      placeholder="ซอย"
                    )

                .col
                  .form-group
                    input.form-control#road(
                      type="text"
                      v-model="form.road"
                      @input="onChange"
                      placeholder="ถนน"
                    )

        .form-item
          .row
            .col-sm-6
              .row
                label.col-sm-4(for="subDistrict") แขวง/ตำบล

                .col-sm-8
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="ตำบล/แขวง"
                  )
                    .form-group
                      thai-address-input(
                        type="subdistrict"
                        v-model="form.sub_district"
                        :input-class="`form-control${errors[0] ? ' is-invalid' : ''}${valid ? ' is-valid' : ''}`"
                        @selected="onSelected"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-6
              .row
                label.col-sm-4.text-right(for="district") อำเภอ/เขต

                .col-sm-8
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="อำเภอ/เขต"
                  )
                    .form-group
                      thai-address-input(
                        type="district"
                        v-model="form.district"
                        :input-class="`form-control${errors[0] ? ' is-invalid' : ''}${valid ? ' is-valid' : ''}`"
                        @selected="onSelected"
                      )
                      span.invalid-feedback {{ errors[0] }}

        .form-item.has-bg
          .row
            .col-sm-6
              .row
                label.col-sm-4(for="province") จังหวัด

                .col-sm-8
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="จังหวัด"
                  )
                    .form-group
                      thai-address-input(
                        type="province"
                        v-model="form.province"
                        :input-class="`form-control${errors[0] ? ' is-invalid' : ''}${valid ? ' is-valid' : ''}`"
                        @selected="onSelected"
                      )
                      span.invalid-feedback {{ errors[0] }}

            .col-sm-6
              .row
                label.col-sm-4.text-right(for="postalCode") รหัสไปรษณีย์

                .col-sm-8
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="รหัสไปรษณีย์"
                  )
                    .form-group
                      thai-address-input(
                        type="postalCode"
                        v-model="form.postal_code"
                        :input-class="`form-control${errors[0] ? ' is-invalid' : ''}${valid ? ' is-valid' : ''}`"
                        @selected="onSelected"
                      )
                      span.invalid-feedback {{ errors[0] }}

        .form-footer
          .d-flex.justify-content-center
            button.next(type="submit") บันทึกและไปขั้นต่อไป
                      
</template>

<script>
import { mapState } from 'vuex'
import IconUploadProfile from '../../icons/UploadProfile.vue'
export default {
  components: { IconUploadProfile },
  // props: {
  //   onNext: {
  //     type: Function
  //   }
  // },

  data: () => ({
    loading: false,
    profileURL: null,
    form: {},
    nameTitle: [
      { label: 'นาย', value: 'นาย' },
      { label: 'นางสาว', value: 'นางสาว' },
      { label: 'นาง', value: 'นาง' },
      { label: 'อื่นๆ โปรดระบุ', value: 'อื่นๆ โปรดระบุ' },
    ],
    maritalStatus: [
      { label: 'โสด', value: 'โสด' },
      { label: 'สมรส', value: 'สมรส' },
      { label: 'หย่า', value: 'หย่า' },
      { label: 'หม้าย', value: 'หม้าย' },
      { label: 'แยกกันอยู่', value: 'แยกกันอยู่' },
    ],
    militaryStatus: [
      { label: 'ยังไม่ได้เกณฑ์', value: 'ยังไม่ได้เกณฑ์' },
      { label: 'ผ่านการเกณฑ์ทหารแล้ว', value: 'ผ่านการเกณฑ์ทหารแล้ว' },
      { label: 'ศึกษาวิชาทหาร', value: 'ศึกษาวิชาทหาร' },
    ],
  }),

  computed: {
    ...mapState(['personalData'])
  },

  mounted() {
    this.form = this.personalData
  },

  methods: {
    onChange() {
      this.$store.commit('SET_PERSONAL_DATA', this.form)
    },

    onSelected(address) {
      this.form.sub_district = address.subdistrict
      this.form.district = address.district
      this.form.province = address.province
      this.form.postal_code = address.postalCode
      this.$store.commit('SET_PERSONAL_DATA', this.form)
    },

    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      // this.step = 2
      this.createImage(files[0])
    },

    createImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.form.profile_url = e.target.result
        this.$store.commit('SET_PERSONAL_DATA', this.form)
      }
      reader.readAsDataURL(file)
    },
  
    onNext() {
      this.loading = true
      console.log('asdasd')
      try {
        this.$store.commit('SET_STEP', 2)
        // const response = await this.$api.user.signUp.create(this.form)
      } catch (error) {
        const errors = error.response.data.errors
        this.$refs.personalDataForm.setErrors(errors)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.profile {
  position: relative;
  height: 80%;
  background: #f1f2f2;
  border: solid 1px #d1d3d4;
  margin-right: 4rem;
  margin-left: 1rem;
  margin-top: 2rem;

  &::after {
    position: absolute;
    bottom: -1px;
    left: -1px;
    right: -1px;
    height: 5px;
    background: #5f80ba;
    content: '';
    z-index: 3;
  }

  .icon {
    width: 60px;
    height: 52px;
    margin-bottom: 10px;
  }

  div {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
  }

  label {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background-size: cover;
    margin: 0;
    font-size: 1.125rem !important;
    cursor: pointer;

    &.is-valid {
      div {
        color: #fff;
        opacity: 0;
      }

      &:hover {
        div {
          opacity: 1;
        }

        &::after {
          position: absolute;
          top: -1px;
          bottom: -1px;
          left: -1px;
          right: -1px;
          background-color: rgba(0, 0, 0, 0.5);
          content: '';
        }
      }
    }

    input {
      position: absolute;
      opacity: 0;
    }
  }
}
</style>